<template>
  <div class="app-container">
    <el-upload
        v-if="!isDestroyed"
        ref="uploadRef"
        style="display: none"
        class="uploadFileBox"
        action="#"
        :multiple="false"
        :http-request="uploadFile">
    </el-upload>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>信息管理</el-breadcrumb-item>
        <el-breadcrumb-item>信息录入</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-divider></el-divider>
    <div class="form-box">
      <el-form :model="informationEntryForm"
               :rules="rules"
               ref="informationEntryForm"
               :label-position="isMobile ? 'top' : 'left'"
               :label-width="isMobile ? '100%' : '100px'"
               @submit.native.prevent>
        <el-form-item label="标题" prop="title">
          <el-col :span="isMobile ? 24 : 6">
            <el-input ref="titleRef"
                      clearable
                      v-model="informationEntryForm.title"
                      placeholder="请输入标题"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="内容" prop="resolution" class="editor-item">
          <el-col :span="24">
            <quill-editor class="solu-editor"
                          ref="mySoluEditor"
                          v-model="informationEntryForm.resolution"
                          :options="resolutionEditorOption"
                          @blur="onEditorBlur($event, 'resolution')"
                          @focus="onEditorFocus($event, 'resolution')"
                          @ready="onResolutionEditorReady($event)"
                          @change="onEditorChange($event, 'resolution')">
            </quill-editor>
          </el-col>
        </el-form-item>
        <el-form-item label="收费标准" required>
          <el-col :span="24" style="padding-left: 20px;">
            <span style="color: #f56c6c; font-size: 20px;">1元/篇</span>
          </el-col>
        </el-form-item>
        <el-form-item class="form-actions">
          <el-button :loading="submitting" type="primary" @click="submitForm('informationEntryForm')" :size="isMobile ? 'medium' : 'default'">立即创建</el-button>
          <el-button @click="resetForm('informationEntryForm')" :size="isMobile ? 'medium' : 'default'">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <insert-link v-if="insertLinkShow" @confirm="insertLink" :visible.sync="insertLinkShow" :insertLinkName="insertLinkName"/>

    <!-- 充值弹窗 -->
    <el-dialog
        title="账户充值"
        :visible.sync="rechargeDialogVisible"
        :close-on-click-modal="false"
        width="90%"
        max-width="500px"
    >
      <div class="welcome-banner">
        <h2>欢迎使用数字资源平台</h2>
      </div>

      <div class="info-box">
        <p><i class="fas fa-clock"></i> 充值后请等待管理员进行审核</p>
      </div>

      <div class="section">
        <div class="section-title">
          <i class="fas fa-money-bill-wave"></i>充值金额
        </div>
        <div class="amount-display">
          <div class="amount-value">¥ {{ amount }}</div>
        </div>
        <div class="fee-info">收费标准：1元/篇</div>
        <div class="hint">单次充值1元，用于支付单次服务费用</div>
      </div>

      <div class="section">
        <div class="section-title">
          <i class="fas fa-credit-card"></i>选择支付方式
        </div>
        <div class="payment-methods">
          <div
              class="payment-method"
              :class="{ active: selectedPayment === '支付宝' }"
              @click="selectedPayment = '支付宝'"
          >
            <i class="fab fa-alipay payment-icon" style="color: #1677ff;"></i>
            <div class="payment-name">支付宝</div>
          </div>
          <div
              class="payment-method"
              :class="{ active: selectedPayment === '微信支付' }"
              @click="selectedPayment = '微信支付'"
          >
            <i class="fab fa-weixin payment-icon" style="color: #07c160;"></i>
            <div class="payment-name">微信支付</div>
          </div>
        </div>
      </div>

      <div class="security-notice">
        <i class="fas fa-shield-alt"></i>
        <span>您的支付信息已加密，安全有保障</span>
      </div>

      <div slot="footer" class="dialog-footer">
        <button class="btn btn-outline" @click="handleCancelRecharge">取消</button>
        <button class="btn btn-primary" @click="handleConfirmRecharge">立即充值</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Quill from 'quill';
import InsertLink from "@/components/quillCom/InsertLink.vue";
import {debounce} from 'lodash';

// 确保Quill正确加载
if (!Quill) {
  console.error('Quill 加载失败，请检查依赖');
}

let fontSizeStyle = Quill.import('attributors/style/size');
//自定义字号
fontSizeStyle.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '22px',
  '24px', '26px', '28px', '30px', '32px', '36px', '38px', '40px', '45px', '50px'];
Quill.register(fontSizeStyle, true);

//自定义字体类型
var fonts = ["Microsoft-YaHei", "SimSun", "SimHei", "KaiTi", "FangSong", "Arial", "sans-serif"];
var Font = Quill.import("formats/font");
// 将字体加入到白名单
Font.whitelist = fonts;
Quill.register(Font, true);

//editor工具栏的工具选项 - 移动端简化
const getToolOptions = (isMobile) => {
  if (isMobile) {
    // 移动端简化工具栏
    return [
      ['bold', 'italic', 'underline'],
      [{list: 'ordered'}, {list: 'bullet'}],
      [{align: []}],
      ['image'],
      ['link'],
      ['clean']
    ];
  }

  // 桌面端完整工具栏
  return [
    ['image'],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{header: 1}, {header: 2}],
    [{list: 'ordered'}, {list: 'bullet'}],
    [{script: 'sub'}, {script: 'super'}],
    [{indent: '-1'}, {indent: '+1'}],
    [{direction: 'rtl'}],
    [{size: fontSizeStyle.whitelist}],
    [{header: [1, 2, 3, 4, 5, 6, false]}],
    [{color: []}, {background: []}],
    [{font: fonts}],
    [{align: []}],
    ['clean'],
    ['link'],
    ['myLink']
  ];
};

const titleConfig = [
  {Choice: '.fileUpload-button', title: '添加图片'},
  {Choice: '.ql-bold', title: '加粗'},
  {Choice: '.ql-italic', title: '斜体'},
  {Choice: '.ql-underline', title: '下划线'},
  {Choice: '.ql-strike', title: '删除线'},
  {Choice: '.ql-blockquote', title: '块引用'},
  {Choice: '.ql-code-block', title: '插入代码段'},
  {Choice: '.ql-header[value="1"]', title: '标题1'},
  {Choice: '.ql-header[value="2"]', title: '标题2'},
  {Choice: '.ql-list[value="ordered"]', title: '编号'},
  {Choice: '.ql-list[value="bullet"]', title: '插入项目符号'},
  {Choice: '.ql-script[value="super"]', title: '上标'},
  {Choice: '.ql-script[value="sub"]', title: '下标'},
  {Choice: '.ql-indent[value="-1"]', title: '向左缩进'},
  {Choice: '.ql-indent[value="+1"]', title: '向右缩进'},
  {Choice: '.ql-direction', title: '文本方向'},
  {Choice: '.ql-size .ql-picker-label', title: '字号'},
  {Choice: '.ql-header .ql-picker-label', title: '标题大小'},
  {Choice: '.ql-color', title: '字体颜色'},
  {Choice: '.ql-background', title: '背景颜色'},
  {Choice: '.ql-font .ql-picker-label', title: '字体'},
  {Choice: '.ql-align', title: '对齐方式'},
  {Choice: '.ql-clean', title: '清除文本格式'},
  {Choice: '.ql-link', title: '设置链接\n选中文字才能设置'},
  {Choice: '.ql-align .ql-picker-item:first-child', title: '向左对齐'},
  {Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐'},
  {Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '向右对齐'},
  {Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐'}
]

// 模拟本地存储工具函数
const localstorage = {
  set: function(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.warn('LocalStorage 存储失败', e);
    }
  },
  get: function(key) {
    try {
      const value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (e) {
      console.warn('LocalStorage 获取失败', e);
      return null;
    }
  }
};

// 测试用户数据
const testUserInfo = {
  id: '123',
  name: '测试用户',
  role: 'admin'
};

// 模拟图片URL库
const mockImageUrls = [
  'https://picsum.photos/800/400?random=1',
  'https://picsum.photos/800/400?random=2',
  'https://picsum.photos/800/400?random=3',
  'https://picsum.photos/800/400?random=4',
  'https://picsum.photos/800/400?random=5'
];

export default {
  name: "InformationEntry",
  components: {InsertLink},
  data() {
    return {
      userInfo: undefined,//登录用户信息
      isDestroyed: false, // 组件销毁标记,避免销毁后操作DOM
      submitting: false, // 提交加载状态
      isMobile: false, // 是否为移动设备
      editorOption: {
        action: '',
        methods: 'post',
        name: 'uploadFile',
        token: '',
        size: 500,
        accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon, image/jpg',
        readyOnly: false,
        theme: 'snow',
        syntax: true,
      },
      resolutionEditorOption: {
        ...this.editorOption,
        modules: {
          toolbar: {
            container: getToolOptions(this.isMobile),
            handlers: {
              'image': () => this.handleImageUpload('resolution'),
              link: () => this.handleLinkInsert('resolution')
            }
          },
        },
      },
      labelPosition: 'left',
      informationEntryForm: {
        title: '',
        description: '',
        resolution: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur'},
          {validator: this.validateTitle, trigger: 'blur'}
        ],
        resolution: [
          {required: true, message: '请填写内容', trigger: 'change'},
          {validator: this.validateEditorContent, trigger: 'change'}
        ]
      },
      resolutionQuill: null,
      insertLinkShow: false,
      insertLinkName: '',
      currentQuill: null,
      imageUpload: false,
      currentEditorType: '',
      // 充值相关数据
      rechargeDialogVisible: false,
      amount: '1.00',
      selectedPayment: '支付宝'
    }
  },
  created() {
    // 使用测试用户信息
    this.userInfo = testUserInfo;
    // 保存到本地存储
    localstorage.set("successInfo", testUserInfo);

    // 初始化判断设备类型
    this.checkDeviceType();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);

  },
  mounted() {
    this.initTitle();
  },
  beforeDestroy() {
    console.log('beforeDestroy - resolutionQuill:', this.resolutionQuill);
    this.isDestroyed = true;
    this.cleanupEventListeners();
    this.destroyEditors();
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 检查设备类型
    checkDeviceType() {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      this.isMobile = isMobile || window.innerWidth < 768;
      // 更新编辑器工具栏配置
      this.updateEditorToolbars();
    },

    // 处理窗口大小变化
    handleResize: debounce(function() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 768;
      if (wasMobile !== this.isMobile) {
        this.updateEditorToolbars();
        // 重新初始化标题提示
        this.initTitle();
      }
    }, 300),

    // 更新编辑器工具栏
    updateEditorToolbars() {
      const toolOptions = getToolOptions(this.isMobile);
      this.resolutionEditorOption.modules.toolbar.container = toolOptions;
    },


    // 初始化标题
    initTitle() {
      this.$nextTick(() => {
        // 设置内容编辑器的占位符
        const soluEditor = document.querySelector('.solu-editor .ql-editor');
        if (soluEditor) {
          soluEditor.dataset.placeholder = '请输入内容';
        }

        // 处理工具栏提示
        titleConfig.forEach(item => {
          try {
            const tipTwo = document.querySelector('.solu-editor ' + item.Choice);
            if (tipTwo) tipTwo.setAttribute('title', item.title);
          } catch (e) {
            console.warn('DOM元素选择失败', e);
          }
        });
      });
    },

    // 编辑器失去焦点
    onEditorBlur(quill, editorType) {
      if (editorType === 'resolution' && quill) {
        this.resolutionQuill = quill;
      }
    },

    // 编辑器获得焦点
    onEditorFocus(quill, editorType) {
      this.onEditorBlur(quill, editorType);
    },

    // 编辑器内容变化
    onEditorChange({html}, editorType) {
      if (editorType === 'resolution') {
        this.informationEntryForm.resolution = html || '';
      }
    },

    // 解决方法编辑器准备就绪
    onResolutionEditorReady(quill) {
      this.resolutionQuill = quill;
    },

    // 标题输入框聚焦
    onTitleRef() {
      this.$nextTick(() => {
        const titleRef = this.$refs.titleRef;
        if (titleRef) {
          titleRef.focus();
        }
      });
    },

    // 表单提交 - 显示充值弹窗
    submitForm(formName) {
      if (this.submitting) return;

      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // 表单验证通过后显示充值弹窗
          this.rechargeDialogVisible = true;
        } else {
          console.log('表单验证失败');
          // 移动端自动滚动到第一个错误项
          if (this.isMobile) {
            const errorEl = document.querySelector('.el-form-item__error');
            if (errorEl) {
              errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
          return false;
        }
      });
    },

    // 重置表单
    resetForm(formName) {
      const form = this.$refs[formName];
      if (form) {
        form.resetFields();
        if (this.resolutionQuill) {
          this.resolutionQuill.setText('');
          this.informationEntryForm.resolution = '';
        }
      }
    },

    // 处理图片上传 - 使用模拟图片
    handleImageUpload(editorType) {
      this.currentEditorType = editorType;
      this.imageUpload = true;
      this.currentQuill = this.resolutionQuill;

      if (this.$refs.uploadRef) {
        this.$nextTick(() => {
          const input = this.$refs.uploadRef.$el.querySelector('input');
          if (input) {
            input.click();
          }
        });
      }
    },

    // 处理链接插入
    handleLinkInsert(editorType) {
      this.currentEditorType = editorType;
      this.currentQuill = this.resolutionQuill;

      if (this.currentQuill) {
        const range = this.currentQuill.getSelection();
        let text = '';
        if (range && range.length > 1) {
          text = this.currentQuill.getText(range.index, range.length);
        }
        this.insertLinkName = text;
        this.insertLinkShow = true;
      }
    },

    // 上传文件 - 模拟上传
    uploadFile(file) {
      if (!file.file) return;

      // 模拟上传延迟
      setTimeout(() => {
        try {
          // 随机选择一个模拟图片URL
          const randomIndex = Math.floor(Math.random() * mockImageUrls.length);
          const mockUrl = mockImageUrls[randomIndex];

          if (this.imageUpload) {
            this.saveImageLink(this.currentQuill, mockUrl);
          } else {
            // 模拟文件链接
            const fileName = file.file.name;
            this.saveLink(this.currentQuill, `https://example.com/files/${fileName}`, fileName, true);
          }

          this.$message.success('文件上传成功');
        } catch (err) {
          console.error('文件上传错误', err);
          this.$message.error('文件上传失败，请重试');
        }
      }, 800);
    },

    // 保存链接
    saveLink(quill, url, text, isUpload) {
      if (!quill || !url) return;

      text = isUpload ? "附件：" + text : text;
      let index = quill.selection.savedRange?.index;

      if (!index) {
        index = quill.getLength();
      }

      const range = quill.getSelection();
      if (range) {
        quill.deleteText(range.index, range.length);
      }
      quill.insertText(index, text, 'link', url);
      index += text.length;
      quill.setSelection(index);
    },

    // 保存图片链接
    saveImageLink(quill, url) {
      if (!quill || !url) return;

      let index = quill.selection.savedRange?.index;

      if (!index) {
        index = quill.getLength();
      }

      const range = quill.getSelection();
      quill.insertText(range.index, "\n\n");
      quill.insertEmbed(range.index + 4, 'image', url);
      index += 5; // 调整光标位置
      quill.setSelection(index);
    },

    // 插入链接
    insertLink(data) {
      if (!data || !data.url) return;

      this.saveLink(this.currentQuill, data.url, data.text || '链接');
      this.insertLinkShow = false;
    },

    // 自定义验证器 - 标题
    validateTitle(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入标题'));
      } else if (value.length < 3) {
        callback(new Error('标题长度至少3个字符'));
      } else if (value.length > 30) {
        callback(new Error('标题长度不能超过30个字符'));
      } else if (/[<>\\/"]/.test(value)) {
        callback(new Error('标题不能包含特殊字符: < > \ / "'));
      } else {
        callback();
      }
    },

    // 自定义验证器 - 编辑器内容
    validateEditorContent(rule, value, callback) {
      if (!value || (typeof value === 'string' && value.trim() === '')) {
        callback(new Error('内容不能为空'));
      } else {
        callback();
      }
    },

    // 清理事件监听器
    cleanupEventListeners() {
      // 清理自定义事件
    },

    // 销毁编辑器实例
    destroyEditors() {
      if (this.resolutionQuill && this.resolutionQuill.destroy instanceof Function) {
        this.resolutionQuill.destroy();
        this.resolutionQuill = null;
      }
    },

    // 充值相关方法
    handleConfirmRecharge() {
      this.submitting = true;
      // 模拟支付过程
      setTimeout(async () => {
        try {
          // 显示支付确认信息
          this.$alert(
              `您选择了充值 ¥${this.amount}，使用 ${this.selectedPayment} 支付\n\n充值后请等待管理员审核，审核通过后即可使用平台资源`,
              '充值确认',
              {
                confirmButtonText: '确定',
                callback: async () => {
                  // 模拟API请求延迟
                  await new Promise(resolve => setTimeout(resolve, 1000));

                  // 模拟成功响应
                  const mockResponse = {
                    code: 200,
                    message: '信息创建成功',
                    data: {
                      id: Date.now(), // 使用时间戳作为模拟ID
                      ...this.informationEntryForm,
                      createTime: new Date().toLocaleString()
                    }
                  };

                  // 保存到本地存储作为模拟数据库
                  const savedData = localstorage.get('informationData') || [];
                  savedData.push(mockResponse.data);
                  localstorage.set('informationData', savedData);

                  this.$message.success({
                    message: mockResponse.message,
                    onClose: () => {
                      this.rechargeDialogVisible = false;
                      this.resetForm('informationEntryForm');

                    }
                  });
                }
              }
          );
        } catch (err) {
          console.error('充值或提交失败', err);
          this.$message.error('操作失败，请重试');
        } finally {
          this.submitting = false;
        }
      }, 800);
    },

    handleCancelRecharge() {
      this.$confirm('确定要取消充值吗？', '取消确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '充值已取消'
        });
        this.rechargeDialogVisible = false;
      }).catch(() => {
        // 取消取消操作，不做处理
      });
    }
  },
}
</script>

<style scoped>
.app-container {
  padding: 12px;
  background-color: #f8fafc;
  min-height: 100vh;
  box-sizing: border-box;
}

/* 响应式断点设置 */
@media screen and (min-width: 768px) {
  .app-container {
    padding: 24px;
  }
}

.breadcrumb {
  margin-bottom: 16px;
}

.solu-editor >>> .ql-snow .ql-editor img,
.ques-editor >>> .ql-snow .ql-editor img {
  max-width: 100%;
  height: auto;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-crisp-edges;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}

.el-divider {
  background-color: #C0C4CC;
  margin: 18px 0;
}

.form-box {
  padding: 0 15px;
}

@media screen and (min-width: 768px) {
  .form-box {
    padding: 0 30px 0 20px;
  }
}

.form-box >>> .el-form-item__label {
  font-size: 16px;
  font-weight: 400;
}

.form-box >>> .el-form-item__error {
  color: #f23c3c;
  font-size: 14px;
  /* 移动端错误提示位置调整 */
  position: static;
  display: block;
  margin-top: 4px;
}

/* 编辑器样式优化 */
.quill-editor {
  height: auto;
  min-height: 200px;
}

@media screen and (max-width: 767px) {
  .quill-editor {
    min-height: 150px;
  }

  /* 移动端编辑器工具栏优化 */
  .quill-editor >>> .ql-toolbar.ql-snow {
    flex-wrap: wrap;
    padding: 4px 8px;
  }

  .quill-editor >>> .ql-toolbar.ql-snow .ql-formats {
    margin: 4px 2px;
  }

  .quill-editor >>> .ql-snow .ql-picker-label {
    padding: 2px 8px;
  }
}

/* 编辑器内容区域 */
.quill-editor >>> .ql-container {
  min-height: inherit;
  font-size: 16px;
  border-top: 1px solid #e5e6eb !important;
}

/* 表单按钮区域 */
.form-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  flex-wrap: wrap;
}

@media screen and (max-width: 767px) {
  .form-actions {
    flex-direction: column;
  }

  .form-actions >>> .el-button {
    width: 100%;
  }
}

/* 编辑器项间距 */
.editor-item {
  margin-bottom: 16px !important;
}

/* 移动端表单元素优化 */
@media screen and (max-width: 767px) {
  .form-box >>> .el-select,
  .form-box >>> .el-cascader,
  .form-box >>> .el-input {
    width: 100% !important;
  }

  .form-box >>> .el-form-item {
    margin-bottom: 16px;
  }
}

/* 解决移动端弹窗被键盘遮挡问题 */
@media screen and (max-width: 767px) {
  .v-modal {
    position: fixed !important;
  }

  .el-dialog {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    top: auto !important;
    margin: 0 !important;
    width: 100% !important;
    border-radius: 12px 12px 0 0 !important;
    max-height: 80vh !important;
  }
}

/* 工具栏图标提示 */
.quill-editor >>> .ql-snow .ql-tooltip {
  z-index: 9999;
}

/* 充值弹窗样式 */
.welcome-banner {
  background-color: #1890ff;
  color: white;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 24px;
  text-align: center;
}

.welcome-banner h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #595959;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 8px;
  color: #1890ff;
}

.amount-display {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 16px;
  background-color: #fafafa;
  margin-bottom: 8px;
}

.amount-value {
  font-size: 24px;
  font-weight: 600;
  color: #262626;
}

.hint {
  font-size: 13px;
  color: #8c8c8c;
  text-align: center;
  margin-top: 5px;
}

.fee-info {
  font-size: 14px;
  color: #595959;
  text-align: center;
  margin-top: 8px;
  font-weight: 500;
}

.payment-methods {
  display: flex;
  gap: 12px;
}

.payment-method {
  flex: 1;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 16px 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.payment-method:hover {
  border-color: #1890ff;
  background-color: #f0f8ff;
}

.payment-method.active {
  border-color: #1890ff;
  background-color: #e6f7ff;
}

.payment-icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.payment-name {
  font-size: 14px;
  font-weight: 600;
  color: #595959;
}

.btn {
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 48%;
}

.btn-primary {
  background-color: #1890ff;
  color: white;
  border: 1px solid #1890ff;
}

.btn-primary:hover {
  background-color: #40a9ff;
  border-color: #40a9ff;
}

.btn-outline {
  background-color: transparent;
  border: 1px solid #d9d9d9;
  color: #595959;
}

.btn-outline:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.security-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c8c8c;
  font-size: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
}

.security-notice i {
  margin-right: 6px;
  color: #52c41a;
}

.info-box {
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
}

.info-box p {
  font-size: 13px;
  color: #d46b08;
  margin: 0;
  display: flex;
  align-items: center;
}

.info-box i {
  margin-right: 8px;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
}
</style>